























































































import { defineComponent, inject } from '@vue/composition-api'
import UserAvatar from '@/components/UserAvatar.vue'
import MemberStatusBadge from '@/components/MemberStatusBadge.vue'
import moment from 'moment'
import { useUnsavedWarning } from '@/composables/useUnsavedWarning'
import { useUpdater } from '@/composables/useUpdater'
import { useMutation } from '@vue/apollo-composable'
import userMutation from '@/lib/graphql/user.mutation.gql'
import userQuery from '@/lib/graphql/user.query.gql'

export default defineComponent({
  components: {
    UserAvatar,
    MemberStatusBadge
  },

  setup(_, { root }) {
    const toDate = moment

    // eslint-disable-next-line
    const { data: user, loading } = inject('user') as any

    const { markAsDirty, resetDirty, isDirty } = useUnsavedWarning()
    const {
      updateBag,
      modelProps: { name, email, locale, email_is_valid: emailIsValid },
      onChange
    } = useUpdater(user, ['name', 'email', 'locale', 'email_is_valid'])

    onChange(isEqual => {
      if (isEqual) {
        resetDirty()
      } else {
        markAsDirty()
      }
    })

    const { mutate, loading: isSaving, onError, onDone } = useMutation(
      userMutation,
      () => ({
        variables: {
          id: user.value.id,
          set: updateBag
        },
        update: cache => {
          // eslint-disable-next-line
          const data: any = cache.readQuery({
            query: userQuery,
            variables: { id: user.value.id }
          })

          Object.keys(updateBag)
            .filter(k => typeof updateBag[k] !== 'undefined')
            .forEach(k => {
              data.users_by_pk[k] = updateBag[k]
            })

          cache.writeQuery({
            query: userQuery,
            variables: { id: user.value.id },
            data
          })
        }
      })
    )

    const submit = () => {
      mutate()
    }

    onDone(() => {
      resetDirty()
    })

    // eslint-disable-next-line
    onError((err: any) => {
      console.error(err)
      root?.$message.error('Something went wrong')
    })

    return {
      toDate,
      user,
      loading,

      isDirty,

      updateBag,

      name,
      email,
      locale,
      emailIsValid,

      isSaving,
      submit
    }
  }
})
